<template>
  <b-row class="mt-4">
    <b-col cols="12" class="mb-3">
      <h3>เลือกหมวดหมู่เส้นทาง</h3>
      <small class="text-warning">
        <i class="fas fa-exclamation-circle"></i>
        หากคุณสร้างเส้นทางตั้งต้น สามารถเลือกหมวดหมู่เส้นทางได้
      </small>
    </b-col>
    <b-col cols="6">
      <ValidationProvider rules="required" v-slot="{ errors }">
        <b-form-group label="ระบุหมวดหมู่เส้นทาง">
          <b-form-select
            v-if="!$route.params.id"
            v-model="form.category.id"
            :state="!errors.length ? null : false"
            :disabled="!form.rate_type || !form.customer"
            @input="$emit('setRoutes')">
            <template v-if="form.categoryRoutes.length > 0">
              <b-form-select-option
                v-for="category in filteredCategories"
                :key="category.id"
                :value="category.id">
                {{ category.name }}
              </b-form-select-option>
            </template>
          </b-form-select>
          <b-form-input v-else v-model="form.categoryName" disabled />
          <b-form-invalid-feedback>
            {{ errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </ValidationProvider>
    </b-col>
  </b-row>
</template>

<script>
import customerServices from "@/api/customer.service.js";
import { ValidationProvider } from "vee-validate";

export default {
  props: {
    form: {},
  },
  components: {
    ValidationProvider,
  },
  methods: {
    async getCetegory(categoryId) {
      try {
        const response = await customerServices.getCustomerByOne(categoryId);
        this.form.categoryRoutes = response.data.data.routes;
      } catch (error) {}
    },
  },
  computed: {
    filteredCategories() {
      return this.form.categoryRoutes.filter((category) => {
        if (this.form.rate_type === 1) {
          return category.customer_route_details.length > 2;
        } else {
          return category.customer_route_details.length <= 2;
        }
      });
    },
  },
};
</script>
